/*global BMS*/
import {handleGetStateResponse} from '../../../actions/platformActions';
import {isLocalStorageAvailable, isLocalStorageQuotaExceeded} from '../../../helpers/systemHelpers';
import {getMarketInfo} from '../../../helpers/eventHelpers';
import {
    clearOpenBetsList,
    removeOpenBet,
    toggleCommitBetsError,
    toggleCommitBetsSuccess,
    toggleCommittingBets,
    uncheckQuickFill,
    updateOpenBetStake,
} from '../actions/openBetsActions';
// constants
import {BET_LIMITS} from '../../../constants/betLimits';
import {BASE_VALUE} from "../../../constants/chips";
import {ALERT_NOTIFICATION, PLACED_BETS, RES, SETTLED_BETS, SINGLE, VID, XXX} from '../../../constants/identifiers';
import {getItem, setItem} from "../../../helpers/localStorageHelpers";
import {OPEN_BETS, UNREAD_BETS} from "../../../constants/localStorage";
import {calculateEachWayValues} from "../../../helpers/eachWayBetHelpers";
import {
    getDecimalSeparatorFromLanguage,
    getFormattedCurrency,
    usingNonDecimalCurrency
} from "../../../helpers/localization";
import {TO_WIN} from "../modules/racing/constants/identifiers";
import {getPotentialReturn, getRoundedOdds, isMatchDay} from "../modules/matchday/helpers/matchdayHelper";
import {OPERATOR} from '../../../constants/operator';
import {rcTotalStakeSingleEvent} from './realityChecker';
import { calculateTimeDifference } from '../../../helpers/helperFunctions';
import { MATCHDAY_MODULE_TYPE } from '../modules/matchday/constants/identifiers';
import {getGameCategoryNameByChannel, getGameByChannel} from './gameHelpers.js';
import {getMinStake,getMaxStake,isMinMaxStakeOverriden} from '../../../helpers/helperFunctions.js';
import {getText} from "../../../helpers/localization";
import { CLOSE_BUTTON_CALL_BACK_TYPE} from "../../../constants/identifiers";

const timeOfPlaceBetsNotificationIcon = 1000;

let placeBetAlreadyClicked = false;

export function placeBets(betsToPlace, store) {
    if (process.env.NODE_ENV !== 'development') {
        return new Promise((resolve, reject) => {

            let totalStake = 0;

            for (let i in betsToPlace) {
                let bet = betsToPlace[i];
                let stake = 0;
                if (usingNonDecimalCurrency(store.getState().vpp.systemCurrency)) {
                    let stakeInputVal = (typeof bet.stake === 'string' && bet.stake.indexOf('.') !== -1) ? bet.stake.replace('.', '') : bet.stake;
                    stake = bet.bets[0].externalRefId ? (Number(stakeInputVal) * 2) : (Number(stakeInputVal));
                } else {
                    stake = bet.bets[0].externalRefId ? (Number(bet.stake) * 2 * BASE_VALUE) : (Number(bet.stake) * BASE_VALUE);
                }
                stake = Math.round(stake);
                totalStake += stake;
                //to set promoid along with placebet
                let promoId = '';
                if(bet.hasOwnProperty('PromoBetId')){
                    promoId = String(bet.PromoBetId);
                }else{
                    promoId = "real_bet";
                }

                bet.bets.forEach((eventBet) => {
                    let mktId = eventBet.market.id;
                    if (mktId.indexOf('_') === -1) {
                        mktId = mktId.replace('-', '_');
                    }
                    let channel = eventBet.game.channel;
                    let externalRefId = bet.bets[0].externalRefId ? eventBet.externalRefId : null;
                    let marketInfo = getMarketInfo(eventBet, store);
                    marketInfo.marketCode = eventBet.betType.code;
                    marketInfo.eachWayRatio = eventBet.event.eachWayRatio;
                    let opaqueData = JSON.stringify(marketInfo);
                    BMS.api.addBet(channel, eventBet.event.eventId, mktId, 0, externalRefId, opaqueData, eventBet.event.eventTimeDate);
                });
                BMS.api.addSelection(stake, bet.bets.length === 1 ? "SINGLE" : "ACCUMULATOR", bet.bets.length === 1 ? 1 : bet.multiplier,promoId);
            }

            BMS.Operator.updateStake(totalStake);
            store.dispatch(toggleCommittingBets());

            if (placeBetAlreadyClicked) {
                BMS.Operator.setOverlayAllowed(false);
            } else {
                placeBetAlreadyClicked = true;
            }

            BMS.api.placeBet((response) => placeBetSuccessfull(response, store.getState().vpp.playerUID, store.dispatch, totalStake, store.getState().vpp.systemCurrency), (error) => placeBetError(error, store.dispatch));
            resolve(store.dispatch);

        });
    } else {
        fakePlaceBets(betsToPlace, store.dispatch);
        store.dispatch(clearOpenBetsList(true));
    }
}

export function fakePlaceBets(response, dispatch) {
    dispatch(toggleCommittingBets());
    setTimeout(() => {
        dispatch(toggleCommittingBets());
    }, timeOfPlaceBetsNotificationIcon);

    setTimeout(() => {
        dispatch(toggleCommitBetsSuccess());
    }, timeOfPlaceBetsNotificationIcon);
    setTimeout(() => {
        dispatch(toggleCommitBetsSuccess());
    }, timeOfPlaceBetsNotificationIcon * 2);

    // setTimeout(() => {   dispatch(toggleCommitBetsError()); }, timeOfPlaceBetsNotificationIcon); setTimeout(() => {
    // dispatch(toggleCommitBetsError()); }, timeOfPlaceBetsNotificationIcon * 2);
}

function placeBetSuccessfull(response, playerUID, dispatch, totalStake, systemCurrency) {
    BMS.Operator.setOverlayAllowed(true);

    if (systemCurrency !== XXX)
        BMS.Operator.postPlaceBet(totalStake);

    dispatch(clearOpenBetsList(true));
    dispatch(toggleCommittingBets());
    dispatch(toggleCommitBetsSuccess());
    setTimeout(() => {
        dispatch(toggleCommitBetsSuccess());
    }, timeOfPlaceBetsNotificationIcon);
    dispatch(handleGetStateResponse(response, playerUID, true));
}

export function placeBetError(error, dispatch) {
    BMS.Operator.setOverlayAllowed(true);
    dispatch(toggleCommittingBets());
    dispatch(toggleCommitBetsError());
    setTimeout(() => {
        dispatch(toggleCommitBetsError());
    }, timeOfPlaceBetsNotificationIcon);

    //if the error has no translation it is treated as an internal error
    let knownErrorCodes = [-32602, -20000, -20001, -20002, -20003, -20004, -10000, -10001, -1000, -999, -998, -997, -996, -995, -994, -980, -979, -978, -977, -976, -975, -974, -973, -972, -971, -970, -969, -968, -967, -966, -965];
    if (knownErrorCodes.includes(Number(error.code))) {
        error = error.code.toString();
    } else {
        error = 'INTERNAL_ERROR';
    }
}

function callBackFunction (store) {
    let betsToPlace = store.getState().vpp.openBetsList.filter((bt) => Number(bt.stake) > 0);
    if (betsToPlace !== undefined && betsToPlace.length > 0) {
        let betStake;
        let potentialReturns;
        let odd;
        let isChanged = false;
        for (let i = 0; i <= betsToPlace.length - 1; i++) {
            if(betsToPlace[i].hasOwnProperty('PromoBetId')){
                continue;
            }
            betStake = Number(betsToPlace[i].stake);
            if (betsToPlace[i].bets.length > 1) {
                let bonusPercentage = OPERATOR.accaBoostBonusEnabled ? JSON.parse(OPERATOR.accaBoostBonusPercentage)[betsToPlace[i].bets.length] : 0;
                potentialReturns = getPotentialReturn(getRoundedOdds(betsToPlace[i].bets, true), betStake, 1, bonusPercentage);
                odd = potentialReturns/betStake;
            } else {
                potentialReturns = betStake * Number(betsToPlace[i].bets[0].market.odds);
                odd = potentialReturns/betStake;
            }

            //Special case for EW bets
            //stake is multiplied and potential returns are higher
            if (betsToPlace[i].bets[0].externalRefId !== undefined) {
                let ewValues = calculateEachWayValues(betStake, Number(betsToPlace[i].bets[0].market.odds), betsToPlace[i].bets[0].event.eachWayRatio);
                potentialReturns = ewValues.potentialReturns;
                odd = potentialReturns/betStake;
            }

            if(potentialReturns > Number(scaleNumber(BET_LIMITS.maxWinnings, store))){
                let maxWinning = Number(scaleNumber(BET_LIMITS.maxWinnings, store));
                let diff = potentialReturns - maxWinning;
                let stakeDiff = diff/odd;
                let adjustedStake = Math.floor((betStake - stakeDiff)*100)/100; 
                let value = getFormattedInputValue(String(adjustedStake), store.getState().vpp.systemLanguage,  store.getState().vpp.systemCurrency)
                store.dispatch(updateOpenBetStake(betsToPlace[i], value));
                isChanged = true;
            }
        }

        // Uncheck quick fill incase it's enabled and checked
        if(isChanged && OPERATOR.quickBetFillEnabled === true && store.getState().vpp.quickFillBoxChecked === true){
            store.dispatch(uncheckQuickFill());
        }
    }
}

export function areBetsToPlaceStakeLimitsValid(store, betsToPlace) {
    function callBackTrigger(){
        callBackFunction(store)
    }
    if (betsToPlace !== undefined && betsToPlace.length > 0) {
        if (OPERATOR.singleBetCommitEnabled && betsToPlace.length !== 1) {
            window.GAME.notifyPlayer(ALERT_NOTIFICATION, ALERT_NOTIFICATION, 'SINGLE_BET_COMMIT_MESSAGE', true);
            return false;
        }
        let betStake;
        let potentialReturns;
        let params =[]
        let messages =[]
        for (let i = 0; i <= betsToPlace.length - 1; i++) {
            betStake = Number(betsToPlace[i].stake);
            if (betsToPlace[i].bets.length > 1) {
                let bonusPercentage = OPERATOR.accaBoostBonusEnabled ? JSON.parse(OPERATOR.accaBoostBonusPercentage)[betsToPlace[i].bets.length] : 0;
                potentialReturns = getPotentialReturn(getRoundedOdds(betsToPlace[i].bets, true), betStake, 1, bonusPercentage);
            } else {
                potentialReturns = betStake * Number(betsToPlace[i].bets[0].market.odds);
            }

            //Special case for EW bets
            //stake is multiplied and potential returns are higher
            if (betsToPlace[i].bets[0].externalRefId !== undefined) {

                let ewValues = calculateEachWayValues(betStake, Number(betsToPlace[i].bets[0].market.odds), betsToPlace[i].bets[0].event.eachWayRatio);
                betStake = ewValues.totalStake;
                potentialReturns = ewValues.potentialReturns;
            }
            let gameChannel = betsToPlace[i].bets[0].event.channel;
            let gameCategory = getGameCategoryNameByChannel(store, gameChannel);
    
            if (usingNonDecimalCurrency(store.getState().vpp.systemCurrency)) {
                if (betStake < Number(scaleNumber(getMinStake(gameCategory), store)) || betStake > Number(scaleNumber(getMaxStake(gameCategory), store))) {
                    if(isMinMaxStakeOverriden()){
                        let game = getGameByChannel(store, gameChannel);
                        let gameName = game ?  getText('betSlip_' + gameCategory, store) : null;
                        if((gameName || params.length == 0) && params.every(item => item[0] !== gameName)) {
                            messages.push('LIST_BET_STAKE_OUT_OF_LIMITS_MESSAGE');
                            params.push([gameName,
                                getFormattedCurrency(store, Number(scaleNumber(getMinStake(gameCategory), store))),
                                getFormattedCurrency(store, Number(scaleNumber(getMaxStake(gameCategory), store)))]);
                        }
                        continue;
                    } else {
                        window.GAME.notifyPlayer(ALERT_NOTIFICATION, ALERT_NOTIFICATION, 'BET_STAKE_OUT_OF_LIMITS_MESSAGE', true, [
                        getFormattedCurrency(store, Number(scaleNumber(getMinStake(gameCategory), store))),
                        getFormattedCurrency(store, Number(scaleNumber(getMaxStake(gameCategory), store)))]);
                        return false;
                    }
                } else if (potentialReturns > Number(scaleNumber(BET_LIMITS.maxWinnings, store))) {
                    if(BET_LIMITS.maxWinningsAutoCorrectEnabled){
                        window.GAME.notifyPlayer(ALERT_NOTIFICATION, ALERT_NOTIFICATION, 'BET_POTENTIAL_RETURNS_OUT_OF_LIMITS_MESSAGE', true,
                        [getFormattedCurrency(store, Number(scaleNumber(BET_LIMITS.maxWinnings, store)))],true,callBackTrigger,CLOSE_BUTTON_CALL_BACK_TYPE);
                    } else{
                        window.GAME.notifyPlayer(ALERT_NOTIFICATION, ALERT_NOTIFICATION, 'BET_POTENTIAL_RETURNS_OUT_OF_LIMITS_MESSAGE', true,
                        [getFormattedCurrency(store, Number(scaleNumber(BET_LIMITS.maxWinnings, store)))],true,null,null);
                    }
                    return false;
                } else if (BET_LIMITS.stakeDivisor !== 1 && betStake % Number(scaleNumber(BET_LIMITS.stakeDivisor, store)) !== 0) {
                    window.GAME.notifyPlayer(ALERT_NOTIFICATION, ALERT_NOTIFICATION, 'BET_NON_DIVISIBLE_MESSAGE', true,
                        [getFormattedCurrency(store, Number(scaleNumber(BET_LIMITS.stakeDivisor, store)))]);
                    return false;
                }
            } else {
                if (betStake < Number(getMinStake(gameCategory) / 100) || betStake > Number(getMaxStake(gameCategory) / 100)) {
                    if(isMinMaxStakeOverriden()){
                        let game = getGameByChannel(store, gameChannel);
                        let gameName = game ?  getText('betSlip_' + gameCategory, store) : null;
                        if((gameName || params.length == 0) && params.every(item => item[0] !== gameName)) {
                            messages.push('LIST_BET_STAKE_OUT_OF_LIMITS_MESSAGE');
                            let param = [gameName, 
                                getFormattedCurrency(store, Number(getMinStake(gameCategory) / 100)),
                                getFormattedCurrency(store, Number(getMaxStake(gameCategory) / 100))];
                            params.push(param);
                        }
                        continue;
                    } else {
                        window.GAME.notifyPlayer(ALERT_NOTIFICATION, ALERT_NOTIFICATION, 'BET_STAKE_OUT_OF_LIMITS_MESSAGE', true, [
                            getFormattedCurrency(store, Number(getMinStake(gameCategory) / 100)),
                            getFormattedCurrency(store, Number(getMaxStake(gameCategory) / 100))]);
                        return false;
                    }
                } else if (potentialReturns > Number(BET_LIMITS.maxWinnings / 100)) {
                    if(BET_LIMITS.maxWinningsAutoCorrectEnabled){
                        window.GAME.notifyPlayer(ALERT_NOTIFICATION, ALERT_NOTIFICATION, 'BET_POTENTIAL_RETURNS_OUT_OF_LIMITS_MESSAGE', true,
                        [getFormattedCurrency(store, Number(BET_LIMITS.maxWinnings / 100))],true,callBackTrigger,CLOSE_BUTTON_CALL_BACK_TYPE);
                    } else {
                        window.GAME.notifyPlayer(ALERT_NOTIFICATION, ALERT_NOTIFICATION, 'BET_POTENTIAL_RETURNS_OUT_OF_LIMITS_MESSAGE', true,
                        [getFormattedCurrency(store, Number(BET_LIMITS.maxWinnings / 100))],true,null,null);
                    }
                    return false;
                } else if (BET_LIMITS.stakeDivisor !== 1 && Number((betStake * 100).toFixed()) % Number(BET_LIMITS.stakeDivisor) !== 0) {
                    window.GAME.notifyPlayer(ALERT_NOTIFICATION, ALERT_NOTIFICATION, 'BET_NON_DIVISIBLE_MESSAGE', true,
                        [getFormattedCurrency(store, Number(BET_LIMITS.stakeDivisor / 100))]);
                    return false;
                }
            }
        }

        if(messages.length > 0) {
            let gameCatgories = [...new Set(store.getState().vpp.games.map(game => game.gameCategory))];
            const indexMap = {};
            gameCatgories.forEach((value, index) => {
                indexMap[value] = index;
            });
            params.sort((a, b) => {
                const indexA = indexMap[a[0]];
                const indexB = indexMap[b[0]];
                return indexA - indexB;
            });
            window.GAME.notifyPlayer(ALERT_NOTIFICATION, ALERT_NOTIFICATION, messages, true, params);
            return false;
        }
        

        //reality checks
        for (let i = 0; i <= betsToPlace.length - 1; i++) {
            if (usingNonDecimalCurrency(store.getState().vpp.systemCurrency)) {
                if (OPERATOR.rcMaxTotalStakeSingleEvent > 0 && rcTotalStakeSingleEvent(store, betsToPlace, betsToPlace[i]) > Number(OPERATOR.rcMaxTotalStakeSingleEvent)) {
                    window.GAME.notifyPlayer(ALERT_NOTIFICATION, ALERT_NOTIFICATION, 'REALITY_CHECK_TOTAL_STAKE_SINGLE_EVENT_WARNING', true, [
                        getFormattedCurrency(store, Number(scaleNumber(OPERATOR.rcMaxTotalStakeSingleEvent, store))),
                    ]);
                    return false;
                }
            } else {
                if (OPERATOR.rcMaxTotalStakeSingleEvent > 0 && rcTotalStakeSingleEvent(store, betsToPlace, betsToPlace[i]) > Number(OPERATOR.rcMaxTotalStakeSingleEvent)) {
                    window.GAME.notifyPlayer(ALERT_NOTIFICATION, ALERT_NOTIFICATION, 'REALITY_CHECK_TOTAL_STAKE_SINGLE_EVENT_WARNING', true, [
                        getFormattedCurrency(store, Number(OPERATOR.rcMaxTotalStakeSingleEvent / 100)),
                    ]);
                    return false;
                }
            }
        }
    }
    return true;
}

export function scaleNumber(number, store) {
    if (usingNonDecimalCurrency(store.getState().vpp.systemCurrency)) {
        return number;
    } else {
        return number / 100;
    }
}

export function updateSportsBookLocalBetsReadStatus(betSlipScreen, playerUID = '') {
    if (isLocalStorageAvailable) {
        let localBets = getItem(playerUID, UNREAD_BETS);
        if (localBets !== null) {
            if (betSlipScreen !== undefined) {
                let currBets = [];

                if (betSlipScreen === PLACED_BETS) {
                    currBets = localBets.placedBets;
                } else if (betSlipScreen === SETTLED_BETS) {
                    currBets = localBets.settledBets
                }

                currBets = currBets.map((cBet) => {
                    cBet.isRead = true;
                    return cBet;
                });

                if (betSlipScreen === PLACED_BETS) {
                    localBets.placedBets = currBets;
                } else if (betSlipScreen === SETTLED_BETS) {
                    localBets.settledBets = currBets;
                }
            }
            setItem(playerUID, UNREAD_BETS, playerUID !== undefined ? localBets : {placedBets: [], settledBets: []});
        }
    }
}

export function updateSportsBookLocalOpenBets(currentOpenBets, playerUID = '') {
    if (isLocalStorageAvailable()) {
        try {
            setItem(playerUID, OPEN_BETS, currentOpenBets);
        } catch (e) {
            if (isLocalStorageQuotaExceeded(e)) { // storage full
                console.warn('Browser local storage is full, open bets cannot be cached.');
            }
        }
    }
}

export function generateId() {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }

    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}

export function isBetValid(value, store, category=null) {

    if (value === undefined) {
        return false;
    }
    //this is required to handle countries with commas as decimal separators
    value = value.replace(',', '.');

    let units = value;
    let decimals;

    if (value.includes('.')) {
        units = value.split('.')[0];
        decimals = value.split('.')[1];
    }

    //(/^\d+(\.\d{0,2})?$/.test(value) && value <= Number(BET_LIMITS.maxStake / 100)
    if (value === '' || (/^\d+(\.\d{0,2})?$/.test(value)
        && units.length <= getMaxStakeLength(store,category)
        && (decimals === undefined || decimals.toString().length <= 2))) {
        return true;
    } else {
        return false;
    }
}

function getMaxStakeLength(store,category) {
    if (usingNonDecimalCurrency(store.getState().vpp.systemCurrency)) {
        return getMaxStake(category).toString().length;
    } else {
        return getMaxStake(category).toString().length - 2;
    }
}

export function getGameCategory(betSelection, store) {
    return store.getState().vpp.games.find(game => game.channel === betSelection.Bets[0].Channel).gameCategory;
}

export function getAllWrappedBets(state, channelId) {
    var wrappedBets = [];
    var eventBets = state.channelEventBets[channelId];

    if (eventBets) {
        var eventIds = Object.keys(eventBets);

        for (var i = 0; i < eventIds.length; i++) {
            var eventId = eventIds[i];
            var bets = eventBets[eventId];

            for (var j = 0; j < bets.length; j++) {
                var wrappedBet = [];
                wrappedBet["Bets"] = [];
                wrappedBet["Bets"].push(bets[j]);
                wrappedBets.push(wrappedBet);
            }
        }
    }

    return wrappedBets;
}

export function getAllWrappedMatchdayBets(state, channelId) {
    var wrappedBets = [];
    var eventBets = state.channelEventBets[channelId];

    if (eventBets) {
        var eventIds = Object.keys(eventBets);

        for (var i = 0; i < eventIds.length; i++) {
            var eventId = eventIds[i];
            var bets = eventBets[eventId];

            for (var j = 0; j < bets.length; j++) {
                if (bets[j].Bets != undefined)
                    wrappedBets.push(bets[j]);      //Accabets
                else {
                    var wrappedBet = [];
                    wrappedBet["Bets"] = [];
                    wrappedBet["Bets"].push(bets[j]);
                    wrappedBets.push(wrappedBet);
                }
            }
        }
    }
    return wrappedBets;
}

export function getMatchdayEventIdsHavingBets(state, selectedMatchday) {

    let eventBets = getAllWrappedMatchdayBets(state, selectedMatchday.channel).filter(
            (pBet) => selectedMatchday.some(selectedMatchdayEvent => pBet.Bets[0].EventId === selectedMatchdayEvent.eventId.toString()) && pBet.Bets[0].Channel === selectedMatchday.channel);

    let eventIdsHavingBets = [];
    if (eventBets && eventBets.length > 0) {
        eventBets.forEach(bet => {
            bet.Bets.forEach(b => {
                if (!(parseInt(b.EventId) in eventIdsHavingBets)) {
                    eventIdsHavingBets.push(parseInt(b.EventId));
                }
            })
        });
    }
    return eventIdsHavingBets;
 }

export function removeExpiredBets(state, store) {
    if (store.getState().vpp.games !== undefined && state.openBetsList.length > 0) {
        let expiredBetsList = state.openBetsList.slice().filter((openBet) => openBet.bets[0].hasExpired && openBet.bets.length === 1);

        if (expiredBetsList !== undefined && expiredBetsList.length > 0) {
            let expiredBetsListLength = expiredBetsList.length;
            expiredBetsList.map((expiredBet,index) => {
                let isLastBet =
                    index === expiredBetsListLength - 1 ? true : false;
                let controllerState = store.getState().vpp.games.find(game => game.channel === expiredBet.bets[0].event.channel).controllerState;
                if (controllerState === VID || controllerState === RES || (controllerState !== undefined && controllerState[1] !== undefined
                    && (controllerState[1] === VID || controllerState[1] === RES))) {
                    store.dispatch(removeOpenBet(expiredBet,isLastBet));
                }
            });
        }
    }
}


export function isEnabledMarket(state, disabledMarkets, channel, marketName) {
    marketName = marketName === TO_WIN.name ? 'win' : marketName;
    let disabledEventMarkets = JSON.parse(disabledMarkets).slice().filter((item) => item.channel.toLowerCase() === channel.toLowerCase());
    if (disabledEventMarkets.length > 0) {
        let disabledMarket = disabledEventMarkets[0].disabledMarkets.slice().filter((disabledMarket) => disabledMarket.toLowerCase() === marketName.toLowerCase());
        if (disabledMarket !== null && disabledMarket.length !== 0)
            return false;
    }
    return true;
}

function isAccaBetExisting(multiBets, newAccaBet) {
    var updatedAcca = undefined;
    multiBets.forEach(function (existingBet) {
        if (existingBet.bets[0].event.leagueDay === newAccaBet[0].bets[0].event.leagueDay && existingBet.bets[0].event.channel === newAccaBet[0].bets[0].event.channel) {
            let uqId = existingBet.bets[0].uniqueId;
            newAccaBet.forEach(function (bet) {
                var foundIndex = existingBet.bets.findIndex(x => x.event.eventId == bet.bets[0].event.eventId
                    && x.event.channel == bet.bets[0].event.channel && x.market.id == bet.bets[0].market.id);
                if (foundIndex < 0) {
                    let newBet = JSON.parse(JSON.stringify(bet.bets[0]));
                    newBet.uniqueId = uqId;
                    existingBet.bets.push(newBet);
                }
            });


            updatedAcca = newAccaBet;
        }
    });
    return updatedAcca;
}

export function _generateAccumulatorBets(openBetsList, newOpenBetsSimpleList) {
    let isAccaBetPresent = false;
    let matchdayBets = openBetsList.filter(bet => bet.bets.length == 1 && isMatchDay(bet.bets[0].event.eventType));
    let multiBets = openBetsList.filter(bet => bet.bets.length > 1 && isMatchDay(bet.bets[0].event.eventType));
    let matchdayChannelMap = matchdayBets.reduce(function (map, bet) {
        if (!map[bet.bets[0].event.channel]) {
            map[bet.bets[0].event.channel] = [];
        }
        map[bet.bets[0].event.channel].push(bet);
        return map;
    }, {});
    Object.keys(matchdayChannelMap).forEach(function (key) {
        let leagueDayMap = matchdayChannelMap[key].reduce(function (map, bet) {
            if (!map[bet.bets[0].event.channel + '_' + bet.bets[0].event.leagueDay]) {
                map[bet.bets[0].event.channel + '_' + bet.bets[0].event.leagueDay] = [];
            }
            map[bet.bets[0].event.channel + '_' + bet.bets[0].event.leagueDay].push(bet);
            return map;
        }, {});

        Object.keys(leagueDayMap).forEach(function (leagueId) {
            let eventArray = []
            if (leagueDayMap[leagueId].length > 1) {
                let isValidAcca = false;
                leagueDayMap[leagueId].forEach(function (bet, index) {
                    if (eventArray.includes(bet.bets[0].event.eventId) && !isValidAcca) {
                        isValidAcca = false;
                    } else {
                        eventArray.push(bet.bets[0].event.eventId);
                    }
                    if (!eventArray.every(id => id === eventArray[0])) {
                        isValidAcca = true;
                    }
                });
                //Check if acca present for any of the event. If yes. Do nothing else update.
                if (isValidAcca) {
                    isAccaBetPresent = true;
                    var updateExistingAcca = isAccaBetExisting(multiBets, leagueDayMap[leagueId]);
                    if (!updateExistingAcca) {
                        let uniqueId = generateId();
                        let accaBet = {};
                        accaBet.bets = [];
                        leagueDayMap[leagueId].forEach(function (betValue) {
                            let betAdd = JSON.parse(JSON.stringify(betValue.bets[0]));
                            betAdd.uniqueId = uniqueId;
                            accaBet.bets.push(betAdd);
                        });
                        let isMultiBetPresent = false;
                        multiBets.forEach(mb => {
                            if (!isMultiBetPresent) {
                                accaBet.bets.forEach(nab => {
                                    if (mb.bets.some(b => b.event.channel === nab.event.channel && b.event.eventId === nab.event.eventId)) {
                                        isMultiBetPresent = true;
                                    }
                                });
                            }
                        })
                        if (!isMultiBetPresent) {
                            openBetsList.push(accaBet);
                            newOpenBetsSimpleList.push(accaBet);
                        } else {
                            isAccaBetPresent = false;
                        }
                    }
                }
            }

        });


    });
    return isAccaBetPresent;
}

export function _updateExistingAccBets(removedBet, openBetsList,newMyOfferList) {
    if (removedBet && removedBet.bets.length == 1) {
        let matchdayBets = openBetsList.filter(bet => bet.bets.length == 1 && isMatchDay(bet.bets[0].event.eventType));
        let betToRemove;
        if (openBetsList.indexOf(openBetsList.find(bet => bet.bets[0].uniqueId === removedBet.bets[0].uniqueId)) >= 0) {
            let multiBets = openBetsList.filter(bet => bet.bets.length > 1 && isMatchDay(bet.bets[0].event.eventType));
            multiBets.forEach(function (multiBet) {
                let eventBet;
                multiBet.bets.forEach(bet => {
                    if (bet.event.eventId === removedBet.bets[0].event.eventId && bet.market.id === removedBet.bets[0].market.id) {
                        eventBet = bet;
                    }
                });
                if (eventBet) {
                    multiBet.bets.splice(multiBet.bets.indexOf(eventBet), 1);
                    //removing accaBet if all the remaining sub-bets are of same event.
                    let accaSubBets = multiBet.bets.filter((bet) => bet.event.eventId === multiBet.bets[0].event.eventId);
                    if (multiBet.bets.length === 1 || accaSubBets.length === multiBet.bets.length) {
                        if(multiBet.hasOwnProperty('PromoBetId')){
                            let promoId = String(multiBet.PromoBetId);
                            let selectedPromo = newMyOfferList.filter(ob => ob.PromoBetId === promoId);
                            //increment freebet count as removed from the selected bet
                            let selectedPromoIndex = newMyOfferList.findIndex(ob => ob.PromoBetId === promoId);
                            newMyOfferList[selectedPromoIndex].PromoBetCnt = selectedPromo[0].PromoBetCnt + 1;
        
                        }
                        openBetsList.splice(openBetsList.indexOf(multiBet), 1);
                    }
                }

            });
        }
    }
}

export function _removeSingleBets(accaBet, openBetsList) {
    accaBet.bets.forEach(subBet => {
        let singleBet = openBetsList.find(bet => bet.bets.length === 1 &&
            bet.bets[0].event.channel === subBet.event.channel && bet.bets[0].event.eventId === subBet.event.eventId &&
            bet.bets[0].market.id === subBet.market.id);
        if (singleBet) {
            openBetsList.splice(openBetsList.indexOf(singleBet), 1);
        }
    });
}

export function _updateAccaBet(placedBet, openBetsList) {
    if (placedBet && placedBet.Bets.length == 1) {
        let opaqueData = JSON.parse(placedBet.Bets[0].OpaqueData);
        let uniqueId = opaqueData.uniqueId;
        if (openBetsList.indexOf(openBetsList.find(bet => bet.bets[0].uniqueId === uniqueId)) >= 0) {
            let multiBets = openBetsList.filter(bet => bet.bets.length > 1 && isMatchDay(bet.bets[0].event.eventType));
            multiBets.forEach(function (multiBet) {
                let eventBet;
                multiBet.bets.forEach(bet => {
                    if (bet.event.eventId === parseInt(placedBet.Bets[0].EventId) && bet.market.id === placedBet.Bets[0].Market.Id) {
                        eventBet = bet;
                    }
                });
                if (eventBet) {
                    multiBet.bets.splice(multiBet.bets.indexOf(eventBet), 1);
                    //removing accaBet if all the remaining sub-bets are of same event.
                    let accaSubBets = multiBet.bets.filter((bet) => bet.event.eventId === multiBet.bets[0].event.eventId);
                    if (multiBet.bets.length === 1 || accaSubBets.length === multiBet.bets.length) {
                        openBetsList.splice(openBetsList.indexOf(multiBet), 1);
                    }
                }

            });
        }
    }
}

export function _removeAccaSingleBets(accaBet, openBetsList) {
    accaBet.Bets.forEach(subBet => {
        let singleBet = openBetsList.find(bet => bet.bets.length === 1 &&
            bet.bets[0].event.channel === subBet.Channel && bet.bets[0].event.eventId === parseInt(subBet.EventId) &&
            bet.bets[0].market.id === subBet.Market.Id);
        if (singleBet && (singleBet.stake === undefined || singleBet.stake === '' || Number(singleBet.stake) === 0)) {
            openBetsList.splice(openBetsList.indexOf(singleBet), 1);
        }
    });
}

export function showBetSummary(showLoadingOverlay, selectedGame, selectedEvent, noMoreBetsEventList, state) {
    let eventBets;
    if (selectedEvent) {
        eventBets = getAllWrappedBets(state, selectedEvent.channel)
            .filter(pBet => pBet.Bets[0].EventId === selectedEvent.eventId.toString() && pBet.Bets[0].Channel === selectedEvent.channel);
    }
    if (selectedEvent
        && !showLoadingOverlay
        && noMoreBetsEventList.some(event => event.eventId === selectedEvent.eventId && event.gameChannel === selectedGame.channel)
        && (selectedGame.controllerState === VID || selectedGame.controllerState === RES)
        && eventBets && eventBets.length > 0
    ) {
        return true;
    }
    return false;
}

//Distribute quick fill stake amount in major currency equally to all selected bets slips
export const getQuickAmountDistribution = (totalStake, minorCurrencyUnits, numberOfBets) => {
   if(totalStake === ''){
    return Array(numberOfBets).fill(null);
   } 
    totalStake = Math.round(totalStake.replace(',', '.') * BASE_VALUE);
    var distribution = Array(numberOfBets);
    var quotient = parseInt(totalStake / numberOfBets);
    var modulus = totalStake % numberOfBets;
    for (var i = 0; i < distribution.length; i++) {
        distribution[i] = quotient;
        if (modulus > 0) {
            distribution[i]++;
            modulus--;
        }
        distribution[i] = minorCurrencyUnits === 0
            ? distribution[i]
            : (distribution[i] / Math.pow(10, minorCurrencyUnits))
    }
    return distribution;
}

export const getFormattedInputValue = (currInputValue, systemLanguage, systemCurrency) => {
    currInputValue = currInputValue.replace(getDecimalSeparatorFromLanguage(systemLanguage), '.');
    if (currInputValue !== '' && !isNaN(currInputValue)) {
        if (usingNonDecimalCurrency(systemCurrency)) {
            currInputValue = this.adjustInputValueToBaseIfNoDecimalPlaceEntered(currInputValue, systemCurrency);
        }
        currInputValue = getFormattedCurrency(undefined, currInputValue, 2, systemLanguage, systemCurrency, false, true);
        return currInputValue;
    }
}

export function getPromoBalances(promoBalances, optedInPromos) {
    if (isLocalStorageAvailable()) {
        let res = [];
        if(optedInPromos !== null && optedInPromos.length > 0){
            res = promoBalances.filter(prBalance => {
                return optedInPromos.find(optInPr => {
                    return (optInPr === prBalance.PromoBetId) || (prBalance.PlayerRejectable === false);
                });
            });
        } else {
            res = promoBalances.filter(prBalance => {
                return prBalance.PlayerRejectable === false;
            });
        }
        res = res.filter((promo,index) => {
            if(promo.PromoBetCnt !== undefined){
                return promo;
            }
        })
        return res;
    }
}

export function getUpdatedPromoBalances(openBetsListData,promoBalance){
    //The purpose of this function is to prevent unnecessary additions of 
    //freebet count to promobalance during settling bets with selected promo in slip tab.
    let filterPromoOpenBetsList = openBetsListData.filter(ob => ob.promo === 'applied');
    filterPromoOpenBetsList.map(openBet => {
        let pId = openBet.PromoBetId;
        let indexPromo = promoBalance.findIndex(ob => ob.PromoBetId === pId);
        if(indexPromo>=0){
        let promoTobeUpdate = promoBalance[indexPromo];
        promoTobeUpdate.PromoBetCnt = promoTobeUpdate.PromoBetCnt - 1;
        promoBalance.splice(indexPromo, 1, promoTobeUpdate);
        }
    })
    return promoBalance;
}

export function getMajorCurrencyPromoBalances(promoBalance,minorCurrencyUnits){
    let convertedPromoBalance = promoBalance.map(pb => {
        if (minorCurrencyUnits === 0) {
            return {...pb,PromoBetValue:pb.PromoBetValue[0]}
        }
        return {...pb,PromoBetValue:pb.PromoBetValue[0] / Math.pow(10, minorCurrencyUnits)};
       
    })
    return convertedPromoBalance;
}

export function amountConvertToMajorCurrency (amount, minorCurrencyUnits){
    if (minorCurrencyUnits === 0) {
        return amount;
    }
    return amount / Math.pow(10, minorCurrencyUnits);
}

export function filterOutRealBetsFromOpenlist(openBetsList){
    //this function will hepls to filter real bets from openbetsList having promo bets
    let openBetsListRealBets = openBetsList.filter((openBet,index) => {
        if(openBet.hasOwnProperty('PromoBetId')){
            return false;
        }
        
        return true;
    });
    return openBetsListRealBets;
}

export function removePromoBetAndAccaBet(openBetsList){
    //this function will hepls to filter real bets from openbetsList having promo bets and acca bet
    let openBetsListRealBets = openBetsList.filter((openBet,index) => {
        if(openBet.hasOwnProperty('PromoBetId')){
            return false;
        }

        if (openBet.hasOwnProperty('multiplier')) {
            return false;
        }
        
        return true;
    });
    return openBetsListRealBets;
}

// Check if there is at least one valid Acca-bet in the slip.
export function isAccaBetPresentInBetSlip(openBetsList) {
    let matchdayBets = openBetsList.filter(bet => bet.bets.length === 1 && isMatchDay(bet.bets[0].event.eventType));
    let leagueAndEventMap = new Map([[String.prototype, [String.prototype]]]);
    matchdayBets.map((m, k) => {
        let eventIdArray = [];
        if (leagueAndEventMap.get(m.bets[0].event.channel + '_' + m.bets[0].event.leagueDay) !== undefined) {
            eventIdArray = [].concat(leagueAndEventMap.get(m.bets[0].event.channel + '_' + m.bets[0].event.leagueDay), [m.bets[0].event.eventId])
        } else {
            eventIdArray.push(m.bets[0].event.eventId)
        }
        leagueAndEventMap.set(m.bets[0].event.channel + '_' + m.bets[0].event.leagueDay, eventIdArray)
    });
    let booleanArray = [];
    leagueAndEventMap.forEach((md, k) => {
        let unique = new Set(md);
        if (unique.size === md.length && md.length > 1) {
            booleanArray.push(true);
        }
    })
    return booleanArray.includes(true);
}

export function isBetSettled(store, betSelection, serverTimeOffset){
    let game = getGameByChannel(store, betSelection.Bets[0].Channel);
    let lastResult = game.lastResult;

    if(game.type === MATCHDAY_MODULE_TYPE && lastResult !== undefined && lastResult.length === 8 ){
        lastResult = lastResult.find((res) => res.eventId === betSelection.Bets[0].EventId);
    }
   if (lastResult !== undefined && lastResult.eventId === betSelection.Bets[0].EventId){
        if(calculateTimeDifference(betSelection.Bets[0].LastUpdatedDate, new Date(Date.now() - serverTimeOffset)) > 10000){
            return true;
        }
        return false;
    }
    return true;
}

export function reportUIBusyState(busy){
    // true or 1 will not block reality checks.
    // 2 or more can also temporarily block reality check popups, and should only be used for short periods of time, in time-critical situations where player input must not be disturbed.
    let status = busy ? "2" : "1";
    process.env.NODE_ENV !== 'development' && BMS.Operator.reportUIBusyState(status)
}


// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/helpers/betHelpers.js